

    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { ControladorInterfaz } from '../../controlador';
    import seguimiento from './envio-seguimiento.vue';
import { Pregunta } from '@/__env/lib/MercadoLibre/Preguntas';
import { Wait } from '@/__env/ext';
import router from '@/__env/router.index';
    @Component( {
        name: "Componente",
        props: {},
        components: {
            seguimiento
        }
    } )
    export default class Componente extends Vue
    {
        @Prop()
        public Controlador: ControladorInterfaz;
        public get Pedido() { return this.Controlador.Pedido; }
        public get Estado() { return this.Controlador.Vista.Estado; }
        public get Cliente() { return this.Controlador.Pedido.Cliente; }
        public get Envio() { return this.Controlador.Pedido.Envio; }

        public Cargando: boolean = false;
        public Preguntas: Pregunta[] = [];
        public Mensajes: number = 0;

        async mounted()
        {
            this.Cargando = true;
            await Wait( 500 );
            this.Preguntas.clear();

            this.Preguntas = await this.Pedido.CargarPreguntas();
            this.Mensajes  = await this.Pedido.CargarMensajes();
            this.Cargando = false;
        }

        public AbrirChat()
        {
            this.$router.push( '/chat?pack=' + this.Pedido.Carrito );
            //window.open( '/#/chat?pack=' + this.Pedido.Carrito );
            //ControladorChat.AbrirEnEmbebido( this.Pedido.Carrito);
        }

        public AbrirPreguntas()
        {
            this.Controlador.Vista.BarraDerecha.Abierto = true;
            this.Controlador.Vista.BarraDerecha.Modo = 'preguntas';

        }
    }

